import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useLockApplicationUserQuery = () => {
  const { mutateAsync, isPending } = useMutation((username: string) =>
    api.post(API_URL.APPLICATION_USER_LOCK_BY_USERNAME(username))
  );

  return {
    lockApplicationUser: mutateAsync,
    isPending,
  };
};

export default useLockApplicationUserQuery;
